import { Footer } from '../components/Footer';
import { GeneralErrorMessage } from '../components/GeneralErrorMessage';
import { Header } from '../components/Header';
import { MembershipForm } from '../container/MembershipForm';

type Props = {
	onAccept: () => void;
	onDecline: () => void;
};

export const Layout: React.FC<Props> = ({ onAccept, onDecline }) => {
	return (
		<div className="mx-auto w-full max-w-[1216px] pt-0 md:w-[740px] md:pt-[5%] lg:w-[960px] xl:w-[1216px]">
			<div className="mx-auto w-full px-0 md:w-4/5 md:px-8 lg:w-1/2">
				<Header />
				<MembershipForm onAccept={onAccept} onDecline={onDecline} />
				<GeneralErrorMessage />
				<Footer />
			</div>
		</div>
	);
};
